module.exports = __webpack_public_path__ + "b837336ccc06be83920dbe9d395374fb.svg";